import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_SEMIDARK} from 'ui-library/Colors';

export function DeepResearchEmptyState(): JSX.Element {
  // TODO: Add a nice empty state
  return <h2 className={css(styles.container)}>Start your research by asking a question</h2>;
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    color: GRAY_SEMIDARK,
    fontSize: '24px',
    fontWeight: 'normal',
  },
});
